import React, { useState, useEffect, useRef, forwardRef } from 'react';
import ReactPlayer from 'react-player';
import Image from '../Image/ImageLazyWrapper';
import styles from './video-player.scss'
import HorizontalProgressBar from './HorizontalProgressBar';
import ThumbnailProgressBar from './ThumbnailProgressBar';
import { streamingDomain, thumbnailDomain } from '../../../config/config-video'
import Tag from 'jd-library/Tag';

const getVideoPlayerProps = (props) => {
	if(props.source === 'YOUTUBE'){
		return {
			url: props.imgURL,
			light: props.status === 'REVIEWED' ? props.thumbnailURL : false,
			config: {
				youtube: {
					playerVars: { showinfo: 1 }
				}
			}
		}
	} else{
		return {
			url: new RegExp('^http(s)*://').test(props?.imgURL) ? props?.imgURL : props?.walkthrough ? props.actualPath : streamingDomain + props?.imgURL,
			light: new RegExp('^http(s)*://').test(props?.thumbnailURL) ? props?.thumbnailURL : thumbnailDomain + props?.thumbnailURL,
			config: {
				file: {
					hlsOptions: {
						maxBufferLength: 15
					}
				}
			}
		}
	}
}

const VideoPlayerWrapper = forwardRef((props,ref) => {
	if (!props.uploaded) {
		return <VideoPlaceHolder
			{...props}
		/>;
	}
	const [tag, toggleTag] = useState(props.showStatusTag);
	const key = useRef('video-player');
	useEffect(() => {
		if(!props.playing){
			key.current = `video-player${+new Date()}`
		}
	}, [props.playing])
	const onVideoClick = (event) => {
		tag && toggleTag(false);
		props.onClick && props.onClick(event)
	}
	if(props.showThumbnail){
		//TODO Shubham
		return (
			<div onClick={onVideoClick} className={props.thumbnailClass || 'show-thumbnail-wrapper'}>
				<Image
					actualPath={props.source == 'YOUTUBE' ? props.thumbnailURL : !(new RegExp('^http(s)*://').test(props.thumbnailURL)) ? `${thumbnailDomain}${props.thumbnailURL}` : `${props.thumbnailURL}`}
					uploaded={true}
					loadOrignal={true}
				/>
				<div className='overlay-div' />
				<i className={`icon-playVideo ${props.iconClass || 'default-icon-holder'}`}></i>
				{props.showStatus && <span className={`status-dot ${props.status === 'REVIEWED' ? 'success' : 'warning'}`} />}
			</div>
		)
	}
	const videoPlayerProps = getVideoPlayerProps(props);

	return (
		<>
			<ReactPlayer
				ref={ref}
				className={styles['video-player-wrapper']}
				controls={!props.autoPlay}
				playing={props.autoPlay || (props.source != 'YOUTUBE' || props.status == 'REVIEWED') && props.playing}
				key={key.current}
				onStart={event => onVideoClick(event)}
				width={'100%'}
				height={'100%'}
				pip={false}
				playIcon={props.autoPlay ? '' : <i className={`icon-playVideo light-player-icon`} />}
				{...props.playerProps}
				{...videoPlayerProps}
			/>
			{tag && props.status === 'UNDER_REVIEW' && (
				<div className={styles['video-player-tag-on']}>
					<Tag variant='warning' children='VIDEO IN REVIEW' />
				</div>
			)}
		</>
	)
});

export const VideoPlaceHolder = props => {
	return (
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: '100%',
			width:'100%'
		}}>
			{props.horizontal ? <HorizontalProgressBar
				{...props}
				videoKey = {props.imgIndex}
			/>: <ThumbnailProgressBar
				{...props}
				videoKey = {props.imgIndex}
			/>}
		</div>
	);
};

export default VideoPlayerWrapper;
